import * as Yup from 'yup'
import { ENDPOINT_PLATFORM } from '../../../../../constants/api'

export const NAME = 'name'
export const PARTNER = 'partner'
export const UTM_MEDIUM = 'utm_medium'
export const AUTH_USER = 'auth_user'
export const SPEND_METRICS = 'spend_metrics'
export const DESCRIPTION = 'short_intro'

export const FACEBOOK_AD_ACCOUNT_CHECKED = 'facebook_ad_account_checked'
export const FACEBOOK_AD_ACCOUNT_ID = 'facebook_ad_account_id'
export const FACEBOOK_AD_ACCOUNT_DATA = 'facebook_ad_account_data'

export const GOOGLE_AD_ACCOUNT_CHECKED = 'google_ad_account_checked'
export const GOOGLE_AD_ACCOUNT_ID = 'google_ad_account_id'
export const GOOGLE_AD_ACCOUNT_DATA = 'google_ad_account_data'

export const DV360_AD_ACCOUNT_CHECKED = 'dv360_ad_account_checked'
export const DV360_AD_ACCOUNT_ID = 'dv360_ad_account_id'
export const DV360_AD_ACCOUNT_DATA = 'dv360_ad_account_data'

export const TIKTOK_AD_ACCOUNT_CHECKED = 'tiktok_ad_account_checked'
export const TIKTOK_AD_ACCOUNT_ID = 'tiktok_ad_account_id'
export const TIKTOK_AD_ACCOUNT_DATA = 'tiktok_ad_account_data'

export const getInitialValues = (editPartnership = {}) => {
  const {
    facebook_ad_account: facebookAdAccountData = {},
    google_ad_account: googleAdAccountData = {},
    dv360_ad_account: dv360AdAccountData = {},
    tiktok_ad_account: tikTokAdAccountData = {}
  } = editPartnership

  return {
    // currently available for edit values
    [NAME]: editPartnership[NAME] || '',
    [PARTNER]: editPartnership[PARTNER] || '',
    [UTM_MEDIUM]: editPartnership[UTM_MEDIUM] || '',
    [AUTH_USER]: editPartnership[AUTH_USER] || '',
    [SPEND_METRICS]: editPartnership[SPEND_METRICS] || false,
    [DESCRIPTION]: editPartnership[DESCRIPTION] || '',
    // facebook
    [FACEBOOK_AD_ACCOUNT_CHECKED]: !!Object.keys(facebookAdAccountData).length,
    [FACEBOOK_AD_ACCOUNT_ID]: facebookAdAccountData['external_id'] || '',
    [FACEBOOK_AD_ACCOUNT_DATA]: facebookAdAccountData,
    // google
    [GOOGLE_AD_ACCOUNT_CHECKED]: !!Object.keys(googleAdAccountData).length,
    [GOOGLE_AD_ACCOUNT_ID]: googleAdAccountData['external_id'] || '',
    [GOOGLE_AD_ACCOUNT_DATA]: googleAdAccountData,
    // dv360
    [DV360_AD_ACCOUNT_CHECKED]: !!Object.keys(dv360AdAccountData).length,
    [DV360_AD_ACCOUNT_ID]: dv360AdAccountData['external_id'] || '',
    [DV360_AD_ACCOUNT_DATA]: dv360AdAccountData,
    // tiktok
    [TIKTOK_AD_ACCOUNT_CHECKED]: !!Object.keys(tikTokAdAccountData).length,
    [TIKTOK_AD_ACCOUNT_ID]: tikTokAdAccountData['external_id'] || '',
    [TIKTOK_AD_ACCOUNT_DATA]: tikTokAdAccountData
  }
}

export const getValidationSchema = ({ showPartnerSelector = true }) =>
  Yup.object({
    [NAME]: Yup.string().required('Please enter name').max(255, 'Name should have maximum 255 characters'),
    ...(showPartnerSelector && {
      [PARTNER]: Yup.string().required('Please select partner')
    }),
    [FACEBOOK_AD_ACCOUNT_DATA]: Yup.object().when(FACEBOOK_AD_ACCOUNT_CHECKED, {
      is: true,
      then: () =>
        Yup.object().test({
          message: 'Please enter and test ad account',
          test: value => !!Object.keys(value).length
        })
    }),
    [GOOGLE_AD_ACCOUNT_DATA]: Yup.object().when(GOOGLE_AD_ACCOUNT_CHECKED, {
      is: true,
      then: () =>
        Yup.object().test({
          message: 'Please enter and test ad account',
          test: value => !!Object.keys(value).length
        })
    }),
    [DV360_AD_ACCOUNT_DATA]: Yup.object().when(DV360_AD_ACCOUNT_CHECKED, {
      is: true,
      then: () =>
        Yup.object().test({
          message: 'Please enter and test ad account',
          test: value => !!Object.keys(value).length
        })
    }),
    [TIKTOK_AD_ACCOUNT_DATA]: Yup.object().when(TIKTOK_AD_ACCOUNT_CHECKED, {
      is: true,
      then: () =>
        Yup.object().test({
          message: 'Please enter and test ad account',
          test: value => !!Object.keys(value).length
        })
    })
  })

export const transformValuesToBE = values => ({
  [NAME]: values[NAME],
  [PARTNER]: values[PARTNER],
  [UTM_MEDIUM]: values[UTM_MEDIUM],
  [AUTH_USER]: values[AUTH_USER],
  [SPEND_METRICS]: values[SPEND_METRICS],
  [DESCRIPTION]: values[DESCRIPTION]
})

const createAdAccountPayload = ({ platform, ...adAccountData }) => {
  return {
    ...adAccountData,
    provider: ENDPOINT_PLATFORM[platform],
    currency_symbol: adAccountData.currency_symbol || '$'
  }
}

export const transformAdAccountsToBE = values => {
  const adAccounts = []

  if (values[FACEBOOK_AD_ACCOUNT_CHECKED] && Object.keys(values[FACEBOOK_AD_ACCOUNT_DATA]).length) {
    adAccounts.push(createAdAccountPayload(values[FACEBOOK_AD_ACCOUNT_DATA]))
  }

  if (values[GOOGLE_AD_ACCOUNT_CHECKED] && Object.keys(values[GOOGLE_AD_ACCOUNT_DATA]).length) {
    adAccounts.push(createAdAccountPayload(values[GOOGLE_AD_ACCOUNT_DATA]))
  }

  if (values[DV360_AD_ACCOUNT_CHECKED] && Object.keys(values[DV360_AD_ACCOUNT_DATA]).length) {
    adAccounts.push(createAdAccountPayload(values[DV360_AD_ACCOUNT_DATA]))
  }

  if (values[TIKTOK_AD_ACCOUNT_CHECKED] && Object.keys(values[TIKTOK_AD_ACCOUNT_DATA]).length) {
    adAccounts.push(createAdAccountPayload(values[TIKTOK_AD_ACCOUNT_DATA]))
  }

  return {
    ...(adAccounts.length && { external_accounts: adAccounts })
  }
}
